import { Mapper } from 'src/base/mapper'
import { SubscriptionTypeEntity } from 'src/data/entities/subscription.entity'
import { SubscriptionTypeModel } from 'src/domain/models/subscription.model'

export class SubscriptionMapper extends Mapper<SubscriptionTypeEntity, SubscriptionTypeModel> {
	mapFrom(param: SubscriptionTypeEntity): SubscriptionTypeModel {
		return {
			statusName: param?.statusName,
			status: param?.status,
			subscriptionId: param?.subscriptionId,
			clientId: param?.clientId,
			trialDay: param?.trialDay,
			totalAmount: param?.totalAmount,
			dateStartOn: param?.dateStartOn,
			dateNextBilling: param?.dateNextBilling,
			dateLastBilling: param?.dateLastBilling,
			isNeverExpire: param?.isNeverExpire,
			expireCycle: param?.expireCycle,
			paymentGateway: param?.paymentGateway,
			paymentTerm: param?.paymentTerm,
			subscriptionItem: param?.subscriptionItem,
			subscriptionItems: param?.subscriptionItems,
			type: param?.type,
			dateTrialExpire: param?.dateTrialExpire,
			dateUpdated: param?.dateUpdated,
			datePostPaidBilling: param?.datePostPaidBilling,
		}
	}

	mapTo(param: SubscriptionTypeModel): SubscriptionTypeEntity {
		return {
			subscriptionId: param?.subscriptionId,
			clientId: param?.clientId,
			dateStartOn: param?.dateStartOn,
			dateNextBilling: param?.dateNextBilling,
			dateLastBilling: param?.dateLastBilling,
			dateTrialExpire: param?.dateTrialExpire,
			dateUpdated: param?.dateUpdated,
			isNeverExpire: param?.isNeverExpire,
			expireCycle: param?.expireCycle,
			trialDay: param?.trialDay,
			paymentGateway: param?.paymentGateway,
			paymentTerm: param?.paymentTerm,
			totalAmount: param?.totalAmount,
			status: param?.status,
			statusName: param?.statusName,
			type: param?.type,
			productId: null,
			subscriptionItems: param?.subscriptionItems,
			subscriptionItem: param?.subscriptionItem,
			invoices: null,
			invoice: null,
			activity: null,
			subAction: null,
			isForUpgrade: null,
			isAutoAdjustSeat: null,
			pricePerSeat: null,
			additionalSeats: null,
			isCoreCreated: null,
			productName: null,
			planName: null,
			billingInterval: null,
			billEvery: null,
			dateExpire: null,
			isExtend: null,
			isAdvanceInvoice: null,
			isUseImplementationFee: null,
			implementCost1: null,
			implementCost2: null,
			isImplementationFeeCompleted: null,
			isDowngrade: null,
			couponId: null,
			datePostPaidBilling: param?.datePostPaidBilling,
			trialPlanId: null,
			dateTrialPlanExpire: null,
		}
	}
}
